import React from 'react';

const TotalApprovedIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13 5H21M13 12H21M13 19H21M3 17L5 19L9 15M3 7L5 9L9 5'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TotalApprovedIcon;
